export default `
  type Controls {
    searchText: String
    showPasswordDialog: Boolean
    email: String
    service: String
    newService: String
    showForgotDialog: Boolean
    showLinkDialog: Boolean
    showVerificationDialog: Boolean
    routerFrom: String
    routerTo: String
    playing: String
    targetType: String
    vimeoReconnect: Boolean
    vimeoUserSearchText: String
    vimeoUserSelectedID: String
    vimeoVideoSearchText: String
    showVimeo: Boolean
    showViLabelStats: Boolean
    showPersona: Boolean
    selectedType: String
    saveInProgress: Boolean
    vimeoNavigateAfterAdd
    autoFilmLabelling
    createVerification
  }
  type ElDefaultInclude {
    key: String!
    weight: Float
  }
  type ElDefault {
    itemType: String
    DefaultIncludes: [ElDefaultInclude]
  }
  type ElDefaults {
    Defaults: [ElDefault]
    ElUses: [String]
  }
  type ProviderAuth {
    uid: String
    providerID: ID
    userID: ID
    displayName: String
    emailVerified: Boolean
    token: String
    photoUrl: String
    email: String
    isAnonymous: Boolean
    ready: Boolean
  }
  type Toaster {
    header: String
    message: String
    color: String
    type: String
    mobile: Boolean
    showToast: Boolean
  }
  type SearchVariables {
    limit: Int
    offset: Int
    filters: [Filter]
    value: String
    filters: String
  }
  type SearchVariableFilters {
    SearchFilters: [SearchFilter]!
  }
  type SearchFilter {
    itemType: String!
    value: Filter
  }
  type Filter {
    value: [String]
    op: String
    valueKey: String
  }
`
